import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { apiClient, flowTypes } from '@store/index';
import { Resource } from '@store/types';
import { isAxiosError } from 'axios';

export const getServices = createAsyncThunk('flow/getService', async () => {
  try {
    const response = await apiClient.get('/workspaces');
    return response?.data;
  } catch (error) {
    if (isAxiosError(error)) return error.response?.data;
    return { error: 'Unable to get workspaces.' };
  }
});

export type Services = Service[] & { error: string };

export type PermissionMap = {
  [resource in Resource]: {
    create: boolean;
    read: boolean;
    update: boolean;
    delete: boolean;
  };
};

export type Service = {
  service_id: string;
  requests: NumberConstructor;
  workflow_count: number;
  bucket_count: number;
  secret_count: number;
  service_name: string;
  created_by: string;
  updated_by: string;
  created_at: string;
  updated_at: string;
  permissions: PermissionMap;
  admin: boolean;
};

export const getServicesThunk = (builder: ActionReducerMapBuilder<flowTypes>) => {
  return [
    builder.addCase(getServices.pending, (state: flowTypes) => {
      state.flowLoading = true;
      state.flowError = null;
    }),
    builder.addCase(getServices.fulfilled, (state: flowTypes, action: PayloadAction<Services>) => {
      const payload = action.payload;
      state.flowLoading = false;

      if (payload?.error) {
        state.flowError = action.payload.error;
        return;
      }

      state.flowError = null;
      if (Array.isArray(payload)) state.services = payload;
      else state.services = [];
    }),
    builder.addCase(getServices.rejected, (state: flowTypes) => {
      state.flowLoading = false;
    }),
  ];
};
